import {Component, Input} from '@angular/core';
import {ResultatService} from '../../../services/resultat.service';
import {ResultatSumma} from '../../../shared/models/resultat-summa.model';
import {Resultat} from '../../../shared/models/resultat.model';
import {Inkomsttyp} from '../../../shared/enums/inkomsttyp.enum';

@Component({
  selector: 'app-resultat-mobile-table',
  templateUrl: './resultat-mobile-table.component.html',
  styleUrls: ['./resultat-mobile-table.component.scss']
})
export class ResultatMobileTableComponent {
  @Input() resultatDtos: Resultat[];
  @Input() resultatSummaDto: ResultatSumma;

  hasAterbetalningsbelopp = false;

  constructor(
    private readonly resultatService: ResultatService
  ) { }

  tranformDigit(decimal: number): string {
    return this.resultatService.tranformDigitToLocaleString(decimal);
  }

  getInkomsttyp(typ: string): string {
    return Inkomsttyp.RANTA === typ ? 'Ränta' : 'Utdelning';
  }
}
